import React from 'react';
import { Form, Input, Button, Checkbox, Card, Typography, Space, message } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const LoginForm = () => {

  const navigate = useNavigate();
  
  const onFinish = (values) => {
    if (values.username === 'audiencias' && values.password === 'adm159%+') {
      //message.success('Inicio de sesión exitoso');
      setTimeout(() => {
        navigate('/dashboard');
      }, 200);
    } else {
      message.error('Usuario o contraseña incorrectos');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #e6f7ff, #f0f2f5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        transition: 'all 0.3s ease',
      }}
    >
      <Card
        style={{
          maxWidth: 420,
          width: '100%',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
          borderRadius: 12,
          padding: '32px 24px',
          animation: 'fadeIn 0.5s ease-in-out',
        }}        
      >
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div style={{ textAlign: 'center', paddingBottom: 10 }}>
            <LoginOutlined style={{ fontSize: 36, color: '#1890ff' }} />
            <Title level={2} style={{ margin: '16px 0 0' }}>Bienvenido</Title>
            <Text style={{ fontSize: 16, color: '#595959' }}>
              Por favor, ingresa tus credenciales para continuar
            </Text>
          </div>

          <Form
            name="login_form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            layout="vertical"
            style={{ padding: '0 8px' }}
          >
            <Form.Item
              label="Usuario"
              name="username"
              rules={[{ required: true, message: 'Por favor ingresa tu usuario' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Ingresa tu usuario"
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Contraseña"
              name="password"
              rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Ingresa tu contraseña"
                size="large"
              />
            </Form.Item>
            
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                style={{
                  backgroundColor: '#1890ff',
                  borderColor: '#1890ff',
                  transition: 'background-color 0.3s',
                }}
              >
                Iniciar sesión
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
            
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default LoginForm;
